import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { checkHasLiveTag } from "scmp-app/components/article/article-render/helpers";
import type { contentLiveTagContent$key } from "scmp-app/queries/__generated__/contentLiveTagContent.graphql";

import { HomeV2LiveLabel, HomeV2LiveTagContainer, LiveCircle, LiveTag } from "./styles";

type Props = {
  className?: string;
  dimLabelWhenLiveEnds?: boolean;
  hide?: boolean;
  reference: contentLiveTagContent$key;
  variant?: "default" | "homeV2";
};

export const ContentLiveTag: FunctionComponent<Props> = ({
  className,
  dimLabelWhenLiveEnds = false,
  hide = false,
  reference,
  variant = "default",
}) => {
  const content = useFragment(
    graphql`
      fragment contentLiveTagContent on Article {
        ...helpersCheckHasLiveTagArticle
      }
    `,
    reference,
  );

  const hasLiveTag = checkHasLiveTag(content);

  if (!hasLiveTag && !dimLabelWhenLiveEnds) {
    return null;
  }

  if (variant === "homeV2") {
    return (
      <HomeV2LiveTagContainer className={className}>
        <LiveCircle />
        <HomeV2LiveLabel>LIVE</HomeV2LiveLabel>
      </HomeV2LiveTagContainer>
    );
  }

  return (
    <LiveTag $dim={!hasLiveTag && dimLabelWhenLiveEnds} $hide={hide} className={className}>
      LIVE
    </LiveTag>
  );
};

ContentLiveTag.displayName = "ContentLiveTag";
